import { render, staticRenderFns } from "./StaffGroupPageForm.vue?vue&type=template&id=7110d94f&scoped=true&"
import script from "./StaffGroupPageForm.vue?vue&type=script&lang=js&"
export * from "./StaffGroupPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7110d94f",
  null
  
)

export default component.exports